<script setup lang="ts">
/**
 * Public layout — header (nav links, sign-in) + main content + footer.
 */
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader :public-mode="true" />
    <main class="flex-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>
